import { render, staticRenderFns } from "./SpraySynagio.vue?vue&type=template&id=85e3c512&scoped=true&"
import script from "./SpraySynagio.vue?vue&type=script&lang=js&"
export * from "./SpraySynagio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e3c512",
  null
  
)

export default component.exports